import { mutationOptions } from '@tanstack/react-query';
import { http } from '../common/http-client';
import { getBaseTaskListQueryKey } from '../task/api';
import type { ImageGenerationTaskDto } from '../task/model';
import type {
  BatchTranslateImageInputDto,
  GenerateImageInputDto,
  GenerateProductImageInputDto,
  GenerateProductImageOutputDto,
} from './model';

export const generateProductImageMutaionOptions = mutationOptions({
  mutationFn: (input: GenerateProductImageInputDto) => {
    return http
      .post('images/product-image', {
        json: input,
      })
      .json<GenerateProductImageOutputDto>();
  },
});

export const generateImageMutaionOptions = mutationOptions({
  mutationKey: getBaseTaskListQueryKey(),
  mutationFn: (input: GenerateImageInputDto) => {
    return http
      .post('images', {
        json: input,
      })
      .json<ImageGenerationTaskDto>();
  },
});

export const translateImageMutationOptions = mutationOptions({
  mutationKey: getBaseTaskListQueryKey(),
  mutationFn: (input: BatchTranslateImageInputDto) => {
    return http.post('images/translation', {
      json: input,
    });
  },
});
